export default "__VITE_ASSET__b21f9f20__"